var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = _vm.isShow ? _vm.theme() || "" : null
  var m1 = _vm.isShow ? _vm.theme() : null
  var l0 = _vm.isShow
    ? _vm.__map(_vm.listData, function (item, index) {
        var $orig = _vm.__get_orig(item)
        var m2 = _vm.isInArray2(_vm.city_supplier_ids, item.shop_supplier_id)
        return {
          $orig: $orig,
          m2: m2,
        }
      })
    : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        m1: m1,
        l0: l0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }